// 权限管理
import http from '../jslibs/axios/http'

// 权限管理 管理员列表
export const getManagerList = data => http.get('/v1/cms/AdminUser', data)

// 权限管理 获取身份列表

export const getRoleList = data => http.get('/v1/cms/AdminAuthGroup', data)
export const getRoleDetail = (id) => http.get(`/v1/cms/AdminAuthGroup/${id}`)

// 权限管理 新建身份
export const saveRole = data => http.post('/v1/cms/AdminAuthGroup', data)

// 权限管理 编辑身份
export const editRole = (id, data) => http.put(`/v1/cms/AdminAuthGroup/${id}`, data)

// 权限管理 删除身份
export const deleteRole = id => http.delete(`/v1/cms/AdminAuthGroup/${id}`)

// 权限管理 新建管理员
export const saveAdmin = data => http.post('/v1/cms/AdminUser', data)

// 权限管理 编辑管理员
export const editAdmin = (uuid, data) => http.put(`/v1/cms/AdminUser/${uuid}`, data)

// 权限管理 delete管理员
export const deleteAdmin = uuid => http.delete(`/v1/cms/AdminUser/${uuid}`)

export const getAdminDetail = uuid => http.get(`/v1/cms/AdminUser/${uuid}`)

export const getLogList = data => http.get('/v1/cms/AdminActionLog', data)

// 权限管理 菜单列表
export const getMenuList = data => http.get('/v1/cms/AdminAuthMenu', data)

// 权限管理 新增菜单
export const saveMenu = data => http.post('/v1/cms/AdminAuthMenu', data)

// 权限管理 编辑菜单
export const editMenu = (pathParam, data) => http.put(`/v1/cms/AdminAuthMenu/${pathParam}`, data)

// 权限管理 删除菜单
export const deleteMenu = (pathParam, data) => http.delete(`/v1/cms/AdminAuthMenu/${pathParam}`, data)
// 权限管理 获取父级菜单
export const getParentMenu = data => http.get('/v1/cms/AdminAuthMenuSelectList', data)

export const getAdminAuthGroupSelect = () => http.get('/v1/cms/AdminAuthGroupSelect')
